export default __webpack_public_path__ + "static/media/battle-has-begun.c6bf6485.svg";